import React from "react";
import { FormSectionCollapseProvider, type FormSectionCollapseStore } from "../../../../../shared/frontend/components/formSectionCollapse";
import { storedFormSectionCollapsed } from "../app/prefs/formSectionPreferences";
import { useUiPreferences } from "../app/prefs/useUiPreferences";

/** Einklappzustand der Formularabschnitte je Konto in den UI-Präferenzen; einmal an der App-Wurzel. */
export function FormSectionCollapseRoot({ children }: { children: React.ReactNode }) {
  const { prefs, patchPrefs } = useUiPreferences();
  const store = React.useMemo<FormSectionCollapseStore>(() => ({
    isCollapsed: sectionKey => storedFormSectionCollapsed(prefs, sectionKey),
    setCollapsed: (sectionKey, collapsed) => patchPrefs({ collapsedFormSections: { [sectionKey]: collapsed } }),
  }), [prefs, patchPrefs]);
  return <FormSectionCollapseProvider store={store}>{children}</FormSectionCollapseProvider>;
}
